import { render, staticRenderFns } from "./Bullion.vue?vue&type=template&id=0a4fff2b&scoped=true&"
import script from "./Bullion.vue?vue&type=script&lang=js&"
export * from "./Bullion.vue?vue&type=script&lang=js&"
import style0 from "./Bullion.vue?vue&type=style&index=0&id=0a4fff2b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4fff2b",
  null
  
)

export default component.exports